import { BehaviorSubject, Observable } from "rxjs";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { FormGroup } from "@angular/forms";
import { PayTkn } from "src/app/lib/models/pay-tkn";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient) {}
  public tokenSubject: BehaviorSubject<PayTkn> = new BehaviorSubject(null);
  @Output() showUserRegister: EventEmitter<boolean> = new EventEmitter();
  // toogleshowUserRegister(status) {
  //   this.showUserRegister.emit(status);
  // }
  public loginUsuario(param) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let urlProductos = "";
    urlProductos = environment.apiUrl + "/Authentication";
    // const headers1 = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(urlProductos, JSON.stringify(param), {
      headers: headers,
    });
  }
  public isLogin(): boolean {
    let res: any = true;
    if (sessionStorage.getItem("tk") == null) {
      res = false;
    } else {
      let auth: any = JSON.parse(sessionStorage.getItem("tk"));
      if (auth.Token.length == 0 || auth.Usuario == "ANONIMO") {
        res = false;
      }
    }
    return res;
  }

  validUser(param) {
    let urlEmailConfirmed = environment.apiUrl + "/Usuarios/EmailConfirmed";
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.put(urlEmailConfirmed, param, { headers });
  }
  recoveryPass(param) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("ACCESS_TOKEN"),
    });
    let url = environment.apiUrl + "/Usuarios/Recovery";
    return this.http.post(url, JSON.stringify(param), {
      headers: headers,
    });
  }
  exitAccount() {
    sessionStorage.removeItem("tk");
  }

  MatchPassword(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];
      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (
        confirmPasswordControl.errors &&
        !confirmPasswordControl.errors.passwordMismatch
      ) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    };
  }

  getErrorResponse(error) {
    let respuesta: any;
    let status: any;
    // //console.log(error);
    // //console.log(error.error);
    // //console.log(error.error.error);
    // //console.log(error.error.errors);
    if (error.error.errors != null) {
      //console.log("Error1");
      respuesta = {
        titulo: "Error",
        respuesta: JSON.stringify(error.error.errors),
        error: true,
      };
    } else if (error.error.error != null) {
      //console.log("Error2");
      respuesta = {
        titulo: "Error",
        respuesta: error.error.error,
        error: true,
      };
    } else if (error.message != null) {
      //console.log("Error3");
      respuesta = {
        titulo: "Error",
        respuesta: error.message,
        error: true,
      };
    } else if (error.status != null) {
      //console.log("Error4");
      status = error.status;
      respuesta = this.getRespuestaStatus(status);
    } else if (error.error.message != null) {
      //console.log("Error5");
      if (error.error.message != null)
        respuesta = {
          titulo: "Error",
          respuesta: error.error.message,
          error: true,
        };
    } else if (error.status >= 400 && error.status <= 599) {
      if (error.error.errors == null) {
        //console.log("res status true");
        respuesta = {
          titulo: "Error",
          respuesta: this.getRespuestaStatus(error.status),
          error: true,
        };
      } else {
        //console.log("res status false");
        respuesta = {
          titulo: "Error",
          respuesta: JSON.stringify(error.error.errors),
          error: true,
        };
      }
    } else {
      //console.log("Error6");
      respuesta = {
        titulo: "Error",
        respuesta: JSON.stringify(error),
        error: true,
      };
    }
    return respuesta;
  }

  getRespuestaStatus(status): any {
    let respuesta: any;
    switch (status) {
      case 400:
        respuesta = {
          titulo: "Error 400",
          respuesta:
            "Se detecto una sintaxis invalidad, es posible que falten llenar algunos campos obligatorios del formulario",
          error: true,
        };
        break;
      case 401:
        respuesta = {
          titulo: "Error 401",
          respuesta:
            "Su sesion a finalizado, vuelga a registrar sus credenciales",
          error: true,
        };
        break;
      case 403:
        respuesta = {
          titulo: "Error 403",
          respuesta: "El cliente no posee permisos para esta direccion",
          error: true,
        };
        break;
      case 405:
        respuesta = {
          titulo: "Error 405",
          respuesta: "Metodo no implementado",
          error: true,
        };
        break;
      case 408:
        respuesta = {
          titulo: "Error 408",
          respuesta: "Se perdio la conexion, revise su conexion a internet",
          error: true,
        };
        break;
      case 415:
        respuesta = {
          titulo: "Error 415",
          respuesta:
            "El formato multimedia de los datos solicitados no está soportada por el servidor, por lo cual el servidor ha rechaza su solicitud.",
          error: true,
        };
        break;
      case 500:
        respuesta = {
          titulo: "Error 500",
          respuesta:
            "Ocurrio un error en el servidor, Comuniquese con soporte tecnico",
          error: true,
        };
        break;
      case 502:
        respuesta = {
          titulo: "Error 502",
          respuesta:
            "Hay un problema con la página que busca y no se puede mostrar. Cuando el servidor web (actuando como puerta de enlace o proxy) se puso en contacto con el servidor de contenido ascendente, recibió una respuesta no válida del servidor de contenido",
          error: true,
        };
        break;
      case 503:
        respuesta = {
          titulo: "Error 503",
          respuesta: "Servicio no disponible",
          error: true,
        };
        break;
      default:
        respuesta = {
          titulo: "Error",
          respuesta: JSON.stringify("Ocurrio un error"),
          error: true,
        };
        break;
    }
    return respuesta;
  }
  getParamFree(baseUrl: any, urlApi: any, param: any) {
    let ultimocaracter = urlApi.substr(urlApi.length - 1);
    let paramUrl: string = "";
    if (ultimocaracter == "/") {
      param.forEach((el: any) => {
        paramUrl += el.valor + "/";
      });
    } else {
      paramUrl = "?";
      param.forEach((el: any) => {
        if (typeof el.valor != undefined) {
          if (el.valor != null) {
            if (el.valor.length != 0)
              paramUrl += el.clave + "=" + el.valor + "&";
          }
        }
      });
    }

    let resparam = baseUrl + urlApi + paramUrl;
    return this.http.get(resparam, {
      observe: "response",
    });
  }
}
